import { Component, Injector, inject as inject_1 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { MaterialModule, } from "jk-service";
import { StkmmService, templateUrlConfigStk } from './../_service_stk';
import { Stkmm } from '../_entity_stk';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from 'jk-advcom';


@Component({
  selector: 'app-stkmm-edit',
  templateUrl: templateUrlConfigStk.stkmm,
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule,
    AdvComModule,
  ],
})

export class StkmmEditComponent extends JkDialogEditComponent<StkmmService, Stkmm> {
  override dialogRef: MatDialogRef<StkmmEditComponent>;
  override data: jkRestReturn;

  override srv!: StkmmService;
  constructor() {
    const inject = inject_1(Injector);
    const dialogRef = inject_1<MatDialogRef<StkmmEditComponent>>(MatDialogRef);
    const data = inject_1<jkRestReturn>(MAT_DIALOG_DATA);

    super(inject, dialogRef, data);
  
    this.dialogRef = dialogRef;
    this.data = data;
  }


}
